import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDTotalBet implements ICommand
{

	public HostID : number = 0;
	public Amount : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.Amount = ba.readInt53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint53(this.Amount);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDTotalBet();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'Amount(Q)='+this.Amount+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'TotalBet';
	}

}
